import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  OnInit,
  inject,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { UserProfile } from '@/app/pages/admin-options/pages/user-profile/user-profile';

@Component({
  selector: 'ins-creator-profile',
  imports: [UserProfile],
  templateUrl: './profile.html',
  host: { class: 'block h-full min-h-0 w-full min-w-0' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreatorProfile implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly destroyRef = inject(DestroyRef);

  readonly creatorId = signal<string | undefined>(undefined);

  ngOnInit(): void {
    const parent = this.route.parent;
    this.creatorId.set(parent?.snapshot.paramMap.get('creatorId') ?? undefined);

    if (parent) {
      parent.paramMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
        this.creatorId.set(params.get('creatorId') ?? undefined);
        this.cdr.detectChanges();
      });
    }
  }
}
